import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

export type WidgetId = 'fixedDays' | 'recentFixtures' | 'cargoCount' | 'baltic';

const DEFAULT_WIDGET_ORDER: WidgetId[] = ['fixedDays', 'recentFixtures', 'cargoCount', 'baltic'];

interface DashboardLayoutState {
  widgetOrder: WidgetId[];
  saveLayout: (newOrder: WidgetId[]) => void;
  resetLayout: () => void;
  reorderWidgets: (startIndex: number, endIndex: number) => void;
}

export const useDashboardLayoutStore = create<DashboardLayoutState>()(
  devtools(
    persist(
      (set) => ({
        widgetOrder: DEFAULT_WIDGET_ORDER,

        saveLayout: (newOrder: WidgetId[]) => {
          set({ widgetOrder: newOrder });
        },

        resetLayout: () => {
          set({ widgetOrder: DEFAULT_WIDGET_ORDER });
        },

        reorderWidgets: (startIndex: number, endIndex: number) => {
          set((state) => {
            const newOrder = [...state.widgetOrder];
            const [removed] = newOrder.splice(startIndex, 1);
            newOrder.splice(endIndex, 0, removed);
            return { widgetOrder: newOrder };
          });
        },
      }),
      {
        name: 'dashboard-layout',
      }
    ),
    { name: 'DashboardLayoutStore' }
  )
);
